import { Stack } from '@mui/material';
import React, { FC } from 'react';

const urlRegex = /(http[s]?:\/\/[^\s]+)/g;

interface FormattedTextProps {
  text: string;
  style?: React.CSSProperties;
}

const FormattedText: FC<FormattedTextProps> = ({ text, style }) => {
  const lines = text.split('\n');

  return (
    <Stack sx={{ wordBreak: 'break-word' }}>
      <>
        {lines.map((line, lineIndex) => {
          const segments = line.split(urlRegex);

          return (
            <span key={lineIndex}>
              {segments.map((segment, segmentIndex) => {
                if (segment.match(urlRegex)) {
                  return (
                    <a
                      key={segmentIndex}
                      href={segment}
                      target="_blank"
                      rel="noreferrer"
                      className="formatted_text_link"
                      style={{
                        color: '#FFFFFF',
                      }}
                    >
                      {segment}
                    </a>
                  );
                } else {
                  return (
                    <span style={{ ...style }} key={segmentIndex}>
                      {segment}
                    </span>
                  );
                }
              })}
              <br />
            </span>
          );
        })}
      </>
    </Stack>
  );
};

export default FormattedText;
